module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ich01"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/chapter01#ch01"
    }
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/chapter01#ch01"
    }
  }, [_vm._v("Crouching at the Door")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ich02"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alive for the First Time")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ich03"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rage")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ich04"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lust and Adultery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ich05"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lying and Stealing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ich06"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Addiction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ich07"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homosexuality")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ich08"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broken Lives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ich09"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biology Is Not Destiny")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "iapp01"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/appendix#app01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix#app01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Counseling and Ministry Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "inotes"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "author"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/abouttheauthor#author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0